import React from 'react'

const RubroBot = (props) => {   
    if (!props.rubro || !props.categorias){  
        return "CARGANDO"
      }
      const  listaCategorias = props.categorias.map((categoria,i)=>{
        //console.log(props.rubro.nombre+" "+categoria.nombre + '   /productos/' + props.rubro.id + '/' + categoria.id)

        return (
          <div onClick={ ()=> props.go('/productos/'+props.rubro.id+'/'+categoria.id) } key={i}>
            <article className="menuBot">
              <img src={"https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/productos%2F"+categoria.img+"?alt=media"} />
              { categoria.nombre }
            </article>
          </div>
          )
      })

		  return (
        <li className="dropdownNew">
          <p className="dropbtnNew"> <i className="fa fa-angle-down"></i> &nbsp;&nbsp;{props.rubro.nombre}</p>
          <div className="dropdownNew-content">
            {  props.categorias != null  &&
              listaCategorias 
            }
          </div>
        </li>
		  )
}

export default RubroBot




// WEBPACK FOOTER //
// ./src/components/rubro_mod.js